/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {getMarketingUrl} from 'common/util/marketing-url';

import X from '../icons/x.svg';
import type {GdprBanner} from './index';
import translationKeys from './index.i18n';

export function template(this: GdprBanner) {
  const {t} = this.getContext(`i18n`).scoped(translationKeys);
  const {hidden} = this.state;
  const mp23Brand = true;
  return (
    <div sel='.gdpr-banner-container' class={{hidden, 'mp23-brand': mp23Brand}}>
      {mp23Brand ? (
        <>
          <div sel='.gdpr-banner-content'>
            <div>
              {t(`gdpr-banner.cookies-message`)}
              {` `}
              <a attrs={{href: getMarketingUrl(`/legal/privacy-policy`)}}>{t(`gdpr-banner.privacy-policy`)}</a>.
            </div>
            <div sel='.gdpr-banner-buttons'>
              <button sel='.button.gdpr-banner-accept-button' on={{click: this.helpers.onAccept}}>
                {t(`gdpr-banner.accept`)}
              </button>
              <button sel='.button.gdpr-banner-dismiss-button' on={{click: this.helpers.onDismiss}}>
                {t(`gdpr-banner.decline`)}
              </button>
            </div>
          </div>
          <button sel='.gdpr-banner-dismiss' on={{click: this.helpers.onDismiss}}>
            <img attrs={{src: X}} sel='.svg-icon' />
          </button>
        </>
      ) : (
        <>
          <div sel='.gdpr-banner-text'>
            {t(`gdpr-banner.legacy-cookies-intro`)}
            <a attrs={{href: getMarketingUrl(`/legal/privacy-policy`)}}>{t(`gdpr-banner.cookie-policy`)}</a>
            {t(`gdpr-banner.legacy-privacy-intro`)}
            <a attrs={{href: getMarketingUrl(`/legal/privacy-policy`)}}>{t(`gdpr-banner.privacy-statement`)}</a>
            {t(`gdpr-banner.legacy-agreement`)}
          </div>
          <button sel='.gdpr-banner-accept' on={{click: this.helpers.onAccept}}>
            {t(`gdpr-banner.accept`)}
          </button>
          <button sel='.gdpr-banner-accept' on={{click: this.helpers.onDismiss}}>
            {t(`gdpr-banner.reject`)}
          </button>
          <button sel='.gdpr-banner-dismiss' on={{click: this.helpers.onDismiss}}>
            <img attrs={{src: X}} sel='.svg-icon' />
          </button>
        </>
      )}
    </div>
  );
}
